import React, { Component } from 'react'
import { Autocomplete, FormControl, TextField } from '@mui/material'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

class NivoSchemeSelector extends Component {
    getOptions() {
        return [
            'nivo',
            // categorical
            'category10',
            'accent',
            'dark2',
            'paired',
            'pastel1',
            'pastel2',
            'set1',
            'set2',
            'set3',
            // diverging
            'brown_blueGreen',
            'purpleRed_green',
            'pink_yellowGreen',
            'purple_orange',
            'red_blue',
            'red_grey',
            'red_yellow_blue',
            'red_yellow_green',
            'spectral',
            // sequential single hue
            'blues',
            'greens',
            'greys',
            'oranges',
            'purples',
            'reds',
            // sequential multi hue
            'blue_green',
            'blue_purple',
            'green_blue',
            'orange_red',
            'purple_blue_green',
            'purple_blue',
            'purple_red',
            'red_purple',
            'yellow_green_blue',
            'yellow_green',
            'yellow_orange_brown',
            'yellow_orange_red',
        ]
    }

    render() {
        const kedo = this.props.kedo
        const emptyOption = {
            value: '',
            label: kedo.t('Choose an option'),
        }
        const options = [
            emptyOption,
            ...this.getOptions().map((scheme) => ({
                value: scheme,
                label: scheme,
            })),
        ]
        const value =
            options.find(
                (option) => option.value === (this.props.value || '')
            ) || emptyOption

        return (
            <div>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{kedo.t('Color scheme')}</FormInputLabel>
                    <Autocomplete
                        size="small"
                        autoHighlight
                        disableClearable
                        options={options}
                        value={value}
                        getOptionLabel={(option) => option.label || ''}
                        isOptionEqualToValue={(option, selected) =>
                            option.value === selected.value
                        }
                        onChange={(_event, option) =>
                            this.props.onChange?.({
                                target: { value: option?.value || '' },
                            })
                        }
                        renderInput={(params) => (
                            <TextField {...params} size="small" />
                        )}
                    />
                </FormControl>
            </div>
        )
    }
}

export default NivoSchemeSelector
